export default {
    modalShowImageVariations: {
        imageAi: 'Bild-KI',
        regenerateImage: 'Neuen Inhalt generieren',
        description: 'Beschreibung',
        style: 'Stil',
        saveToLibrary: 'In die Bibliothek speichern',
        continue: 'Weiter',
        cancel: 'Abbrechen',
        select: 'Auswählen',
        copy: 'Kopieren',
        selectedImage: 'Ausgewähltes Bild',
        saved: 'Gerettet',
        variations: 'Variationen',
    },
};
